export const ROOT_URL = `${location.protocol}//${location.hostname}${(location.port ? ":"+location.port: "")}`;

const HOST = `${location.hostname}`.replace(".dashboard", "");
const PORT = location.port ? parseInt(location.port) == 3001 ? 3000 : location.port : "";
export const BASE_URL = `${location.protocol}//${HOST}${(PORT ? ":" + PORT : "")}`;

export const CLIENT_PROPERTIES_SIZE = 200;
